import React from "react";
import { ROLE_OPTIONS } from "../../../constants/roles";

const roleLookup = Object.fromEntries(ROLE_OPTIONS.map((opt) => [opt.value, opt]));

export default function RoleChips({ roles }) {
  if (!roles?.length) {
    return <span className="badge text-bg-light border">Roles: (choose)</span>;
  }

  return (
    <div className="d-flex flex-wrap gap-2">
      {roles.map((role) => {
        const opt = roleLookup[role] || {};
        const accent = opt.accent || "secondary";
        const useSuccess = accent === "warning";
        const className = useSuccess
          ? "bg-success-subtle text-success-emphasis"
          : "bg-primary-subtle text-primary-emphasis";
        return (
          <span
            key={role}
            className={`badge ${className} border rounded-pill`}
          >
            {opt.label || role}
          </span>
        );
      })}
    </div>
  );
}
